import {
  createContext,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react';

import { getTwitchToken } from '../firebaseCloud/twitch/getTwitchToken';

export interface TwitchAuthContextType {
  authToken: string;
  clientId: string;
}

const defaultState: TwitchAuthContextType = {
  authToken: '',
  clientId: process.env.NEXT_PUBLIC_TWITCH_CLIENT_ID as string,
};

const TwitchAuthContext = createContext(defaultState);

export function useTwitchAuth() {
  return useContext(TwitchAuthContext);
}

type TwitchAuthContextProps = {
  children: ReactElement;
};

export function TwitchAuthProvider({ children }: TwitchAuthContextProps) {
  const [authToken, setAuthToken] = useState(defaultState.authToken);
  //check if token is valid. provide the token if so, if not, update the token
  useEffect(() => {
    const getNewToken = async () => {
      const { data } = await getTwitchToken({});
      if (data) {
        setAuthToken(data);
      }
    };
    const handler = async () => {
      if (authToken) {
        const res = await fetch('https://id.twitch.tv/oauth2/validate', {
          headers: {
            Authorization: `OAuth ${authToken}`,
          },
        });
        if (res.status !== 200) {
          //the token is invalid
          await getNewToken();
        }
      } else {
        await getNewToken();
      }
    };
    handler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <TwitchAuthContext.Provider
      value={{ authToken, clientId: defaultState.clientId }}
    >
      {children}
    </TwitchAuthContext.Provider>
  );
}
